import React from 'react'

const ClinicalEvidence = () => {
    return (
        <>
             {/* feature container start */}
             <div className="flex flex-wrap lg:flex-nowrap items-center mb-10">
                {/* feature text container start */}
                <div className="order-2 lg:order-1 w-full">
                    <h4 className="feature-heading-a1">
                        Hemodynamic 
                    </h4>
                    <p className = "feature-p-text">
                        The capability of CORCYM’s single bovine pericardial outer layer design to maximize 
                        flow areas through leaflets that open uniformly and wide
                        has demonstrated favorable in-vivo hemodynamic performance since its 
                        introduction in the market in 1982. Literature overviews highlight
                        low pressure gradients, large effective orifice areas and a remarkable 
                        regression on the left ventricular mass.</p>  
                </div>
                {/* feature text container end */}
            </div>
            {/* feature container end */}
            
          
            {/* feature container start */}
            <div className="flex flex-wrap lg:flex-nowrap items-center mb-16">
                
                {/* feature image container start */}
                <div className="order-1 lg:order-2 w-full lg:w-2/4 justify-end mb-4">
                    <img src="/images/crown_prt/Low-Pressure.png" className="mx-auto w-full " />
                </div>
                {/* feature image container end */}

                {/* feature image container start */}
                <div className="order-1 lg:order-2 w-full lg:w-2/4 justify-end mb-4">
                    <img src="/images/crown_prt/Large-Effective.png" className="mx-auto w-full " />
                </div>
                {/* feature image container end */}

                {/* feature image container start */}
                <div className="order-1 lg:order-2 w-full lg:w-2/4 justify-end mb-4">
                    <img src="/images/crown_prt/Remarkable.png" className="mx-auto w-full " />
                </div>
                {/* feature image container end */}
            </div>
            {/* feature container end */}

            { /* feature heading container start */ } 
        <div className = "order-2 lg:order-1 w-full lg:w-4/6" >
            <h4 className = "feature-heading-a1" >
                In-Animal Calcium Absorption Mitigation Testing  </h4> 
        </div> 
        { /* feature heading container end */ }
        <div className="flex flex-wrap lg:flex-nowrap mt-5 items-start">
            {/* feature text container start */}
            <div className="order-2 lg:order-1 w-full lg:w-2/4">
                <p className="text-sm 2xl:text-base mb-8 feature-p-text">
                    By reducing the nucleation sites for calcium deposition - the
                    phospholipids in the pericardial tissue - PRT directly addresses
                    the origin of tissue calcification which may lead to an enhanced
                    valve durability. 
                    <br/>
                    <br/>
                    Tests in subcutaneous rat implants at 60 days demonstrate a
                    significant reduction of calcium content in PRT-treated bovine
                    pericardium patches compared to control.
                    <br/>
                    <br/>
                    <span className = "font-bold feature-p-text">The Phospholipid Reduction Treatment (PRT) process is
                    intended to enhance already proven resilient durability by
                    reducing calcium absorption up to 97% compared to control.<sup>*</sup></span>
                </p>
            </div>
            {/* feature text container end */}

            {/* feature image container start */}
            <div className="order-1 lg:order-2 w-full lg:w-2/4 pl-4 justify-end mb-4">
                <img src="/images/crown_prt/In-Animal.png" className="mx-auto w-full" style={{maxWidth: "600px"}}/>
            </div>
            {/* feature image container end */}
        </div>
        {/* feature container end */}

        { /* feature text container start */ } 
            <div className = "w-full " >
                <p className = "text-sm  mb-6 feature-p-text xl:w-4/5 italic" >
                <sup>*</sup>CORCYM data on file.
                </p>
            </div> 
            { /* feature text container end */ }

        </>
    )
}

export default ClinicalEvidence
